import { useContext } from 'react';
import { Redirect, Route } from 'react-router';
import appContext from '../../context/AppContext';
import {
    getDefaultModulePath,
    hasAnyModuleAccess,
    hasModuleAccess,
    saveCurrentUrl,
} from '../../utils/helpers';
import AuthComponent from './AuthComponent';

const hasPermission = permission =>
    Array.isArray(permission) ? hasAnyModuleAccess(permission) : hasModuleAccess(permission);

const PrivateRoute = ({ permission, component: Component, ...rest }) => {
    const { isAuthenticated } = useContext(appContext);
    const setRedirection = path => {
        saveCurrentUrl();
        return (
            <div>
                <Redirect from={path} to="/login" />
            </div>
        );
    };

    return (
        <Route
            {...rest}
            render={props =>
                isAuthenticated ? (
                    permission && !hasPermission(permission) ? (
                        <Redirect to={getDefaultModulePath()} />
                    ) : (
                        <AuthComponent component={Component} {...props} />
                    )
                ) : (
                    setRedirection(props.path)
                )
            }
        />
    );
};

export default PrivateRoute;
